module.exports = __webpack_public_path__ + "static/media/Singularity3d.4d15f4d7.png";